import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import ReloadPrompt from './pwa/ReloadPrompt.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
      <App />
      <ReloadPrompt/>
  </React.StrictMode>,
)
